module.exports = __webpack_public_path__ + "static/media/YF53_5.74d06250.jpg";